<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { useDataTransfer } from 'dashboard/composables/useDataTransfer';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

/* eslint-disable vue/custom-event-name-casing */
const emit = defineEmits([
  'import',
  'export',
  'manage-labels',
  'manage-fields',
  'start-selection',
]);
/* eslint-enable vue/custom-event-name-casing */

const { t } = useI18n();
const { checkPermissions } = usePolicy();
const { isUnified } = useDataTransfer();
const showActionsDropdown = ref(false);

const transferMenuItems = legacyItems => {
  if (!checkPermissions(['administrator', 'contact_manage'])) return [];
  if (!isUnified.value) return legacyItems;
  return [
    {
      label: t('DATA_TRANSFER.MENU_IMPORT'),
      action: 'import',
      value: 'import',
      icon: 'i-lucide-download',
    },
    {
      label: t('DATA_TRANSFER.MENU_EXPORT'),
      action: 'export',
      value: 'export',
      icon: 'i-lucide-upload',
    },
  ];
};

const menuItems = computed(() => [
  {
    label: t('COMPANIES_BULK_ACTIONS.SELECT_COMPANIES'),
    action: 'start-selection',
    value: 'start-selection',
    icon: 'i-lucide-check-square',
  },
  {
    label: t('COMPANIES_LAYOUT.LABELS.MANAGE_LABELS'),
    action: 'manage-labels',
    value: 'manage-labels',
    icon: 'i-lucide-tag',
  },
  {
    label: t('ATTRIBUTES_MGMT.MANAGE_FIELDS'),
    action: 'manage-fields',
    value: 'manage-fields',
    icon: 'i-lucide-settings-2',
  },
  ...transferMenuItems([
    {
      label: t('COMPANIES_LAYOUT.HEADER.ACTIONS.EXPORT.MENU_LABEL'),
      action: 'export',
      value: 'export',
      icon: 'i-lucide-upload',
    },
    {
      label: t('COMPANIES_LAYOUT.HEADER.ACTIONS.IMPORT.MENU_LABEL'),
      action: 'import',
      value: 'import',
      icon: 'i-lucide-download',
    },
  ]),
]);

const handleAction = ({ action }) => {
  showActionsDropdown.value = false;
  if (action === 'import') emit('import');
  else if (action === 'export') emit('export');
  // eslint-disable-next-line vue/custom-event-name-casing
  // eslint-disable-next-line vue/custom-event-name-casing
  else if (action === 'manage-labels') emit('manage-labels');
  // eslint-disable-next-line vue/custom-event-name-casing
  else if (action === 'manage-fields') emit('manage-fields');
  // eslint-disable-next-line vue/custom-event-name-casing
  else if (action === 'start-selection') emit('start-selection');
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="menuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleAction($event)"
    />
  </div>
</template>
